"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * Función interna de FE-FIREBASE-MODULE, no se debe exponer a les consumidores.
 * Obtiene los usuarios a partir de un parametro, este debe ser verificado que sea válido por
 * fuera de esta función, tanto en tiempo de compilación como de ejecución.
 *
 * @param firestore
 * @param {string} key nombre del parametro a chequear, por ejemplo email
 * @param {string|number} param valor del parametro a chequear, por ejemplo a@gmail.com
 * @returns {Promise<IPatient[]>} Colección de IPatients o null en caso de no encontrar ninguno
 */
async function getUserByParam(firestore, key, param) {
    const path = "user";
    let patientsSnapshot;
    const patients = [];
    const appointmentRef = (0, firestore_1.collection)(firestore, path);
    const appointmentQuery = (0, firestore_1.query)(appointmentRef, (0, firestore_1.where)(key, "==", param));
    try {
        patientsSnapshot = await (0, firestore_1.getDocs)(appointmentQuery);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    if (patientsSnapshot.empty) {
        return null;
    }
    patientsSnapshot.forEach((patient) => {
        patients.push(patient.data());
    });
    return patients;
}
exports.default = getUserByParam;
